import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c4e9785c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "MyWantToBuyList" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "top" }
const _hoisted_4 = { class: "list-info" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "text" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "desc" }
const _hoisted_9 = { class: "address" }
const _hoisted_10 = { class: "add" }
const _hoisted_11 = { class: "date" }
const _hoisted_12 = { class: "time" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("查看详情")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VanImage = _resolveComponent("VanImage")!
  const _component_VanButton = _resolveComponent("VanButton")!
  const _component_VanList = _resolveComponent("VanList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.list.length)
      ? (_openBlock(), _createBlock(_component_VanList, {
          key: 0,
          class: "list",
          loading: $setup.loading,
          "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => (($setup.loading) = $event)),
          onLoad: $setup.getList,
          finished: $setup.finished,
          "immediate-check": false,
          "finished-text": "没有更多了"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.list, (item, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "list-item",
                onClick: ($event: any) => ($setup.router.push({name:"BuyDetail",query:{id:item.id}}))
              }, [
                _createElementVNode("div", _hoisted_3, [
                  (item.photos.length)
                    ? (_openBlock(), _createBlock(_component_VanImage, {
                        key: 0,
                        src: item.photos[0],
                        alt: "图片",
                        width: "96",
                        height: "96",
                        fit: "cover",
                        radius: "4"
                      }, null, 8, ["src"]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createTextVNode(_toDisplayString(item.title) + " ", 1),
                        _withDirectives(_createElementVNode("span", null, "已有" + _toDisplayString(item.quotations) + "人报价", 513), [
                          [_vShow, item.quotations]
                        ])
                      ]),
                      _createElementVNode("div", {
                        class: "btn",
                        onClick: _withModifiers(($event: any) => ($setup.router.push({name:"QuotationOfWantToBuy",query:{id:item.id}})), ["stop"])
                      }, "收到的报价", 8, _hoisted_7)
                    ]),
                    _createElementVNode("div", _hoisted_8, _toDisplayString(item.profile), 1),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, "地址:" + _toDisplayString(item.receiptAddress), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, _toDisplayString($setup.format(Number(item.createTime))), 1),
                  _createVNode(_component_VanButton, {
                    class: "del",
                    type: "danger",
                    plain: "",
                    size: "mini",
                    onClick: _withModifiers(($event: any) => ($setup.del(item.id,idx)), ["stop"])
                  }, {
                    default: _withCtx(() => [
                      _hoisted_13
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_VanButton, {
                    class: "detail",
                    size: "mini"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_14
                    ]),
                    _: 1
                  })
                ])
              ], 8, _hoisted_2))
            }), 256))
          ]),
          _: 1
        }, 8, ["loading", "finished"]))
      : _createCommentVNode("", true)
  ]))
}